import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const preqPaymentMethod = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/prerequisite/payment-methods',
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,
    },
};
